class AuthorImage extends HTMLElement {
    constructor() {
      super();
      this.colorSwatchContainer = this.querySelector(".auth_image");
      if (this.colorSwatchContainer) {
        let authorHandle = this.colorSwatchContainer.getAttribute("author-name");
        if (authorHandle) {
          const modifiedWord = authorHandle.replace(/\s+/g, "");
          let authorStyle = Utility.getAuthorStyle(modifiedWord);
          this.colorSwatchContainer.setAttribute("style", authorStyle);
        }
      }
    }
  }
  customElements.define("author-image", AuthorImage);
  